import { gql, useQuery } from "@apollo/client";
import { captureException } from "@sentry/react";

import FastStartBox from "./FastStartBox";

export default () => {
  // Fetch data
  const GET_FAST_START_DATA = gql`
    query GetFastStartData {
      fastStartData {
        progress
        expires
      }
    }
  `;

  const { loading, data, error } = useQuery(GET_FAST_START_DATA, {
    fetchPolicy: "network-only",
    pollInterval: 10000,
  });

  if (error) {
    console.log("error fetching fast start data", error);
    captureException(error);
  }

  //console.log("data", data);

  return <FastStartBox data={data} />;
};
